import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Label, FormGroup, Input } from 'reactstrap';
import { func, object } from 'prop-types';
import IframeConstructorColorPicker from './IframeConstructorColorPicker';
import IframeConstructorRangeControl from './IframeConstructorRangeControl';
import CustomControl from '../CustomControl/CustomControl';

class IframeConstructorButtonControls extends Component {
  static propTypes = {
    handleButtonChange: func.isRequired,
    validateButtonColor: func.isRequired,
    checkButtonLabel:  func.isRequired,
    settings: object.isRequired,
    config: object.isRequired,
  };

  state = {
    height: 0,
    maxWidth: 0,
    textSize: 0,
    borderRadius: 0,
  };

  componentDidMount() {
    this.setState(() => ({
      height: this.props.settings.button.height,
      maxWidth: this.props.settings.button.maxWidth,
      borderRadius: this.props.settings.button.borderRadius,
      textSize: this.props.settings.button.textSize,
    }));
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.settings.button.height !== this.props.settings.button.height ||
      prevProps.settings.button.maxWidth !== this.props.settings.button.maxWidth ||
      prevProps.settings.button.borderRadius !== this.props.settings.button.borderRadius ||
      prevProps.settings.button.textSize !== this.props.settings.button.textSize
    ) {
      this.setState(() => ({
        height: this.props.settings.button.height,
        maxWidth: this.props.settings.button.maxWidth,
        borderRadius: this.props.settings.button.borderRadius,
        textSize: this.props.settings.button.textSize,
      }));
    }
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(() => ({
      [name]: value,
    }));
  };

  render() {
    const {
      settings,
      config,
      handleButtonChange,
      validateButtonColor,
      checkButtonLabel,
    } = this.props;
    const { height, maxWidth, borderRadius, textSize } = this.state;
    return (
      <div className="iframe-constructor-controls-block">
        <h3 className="iframe-constructor-controls-block-title">
          <FormattedMessage
            id="iframe_constructor.сontrols.button.title"
            defaultMessage="Submit button"
          />
        </h3>

        <Row>
          <Col md="6">
            <IframeConstructorColorPicker
              name="bgColor"
              value={settings.button.bgColor}
              onChange={handleButtonChange}
              validate={validateButtonColor.bind(null, 'bgColor', config.button._DEFAULT_BG_COLOR)}
              id="ic--button-bg-color"
              label={{
                id: 'iframe_constructor.сontrols.button.color.bg',
                defaultMessage: 'Field background color',
              }}
            />
          </Col>
          <Col md="6">
            <IframeConstructorColorPicker
              name="textColor"
              value={settings.button.textColor}
              onChange={handleButtonChange}
              validate={validateButtonColor.bind(
                null,
                'textColor',
                config.button._DEFAULT_TEXT_COLOR,
              )}
              id="ic--button-text-color"
              label={{
                id: 'iframe_constructor.сontrols.button.color.text',
                defaultMessage: 'Field text color',
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col md="8">
            <FormGroup>
              <Label>
                <FormattedMessage
                  id="iframe_constructor.сontrols.button.text.title"
                  defaultMessage="Button text"
                />
              </Label>
              <Input
                type="text"
                id="iframe-constructor-button-text"
                name="text"
                onChange={handleButtonChange}
                onBlur={checkButtonLabel}
                value={settings.button.text}
                bsSize="sm"
              />
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup>
              <Label for="iframe-constructor-button-font-size">
                <FormattedMessage
                  id="iframe_constructor.сontrols.button.text.size"
                  defaultMessage="Size (px)"
                />
              </Label>
              <Input
                type="number"
                id="iframe-constructor-common-font-size"
                name="textSize"
                onChange={this.handleChange}
                onBlur={handleButtonChange}
                value={textSize}
                min={config.button._MIN_FONT_SIZE}
                max={config.button._MAX_FONT_SIZE}
                bsSize="sm"
              />
            </FormGroup>
          </Col>
        </Row>

        <FormGroup>
          <Label for="iframe-constructor-button-height" className="no-margin">
            <FormattedMessage
              id="iframe_constructor.сontrols.button.height.text"
              defaultMessage="Button height (px)"
            />
          </Label>
          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.button.height}
                max={config.button._MAX_HEIGHT}
                min={config.button._MIN_HEIGHT}
                onChange={handleButtonChange}
                name="height"
                step={10}
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-button-height"
                name="height"
                onChange={this.handleChange}
                onBlur={handleButtonChange}
                value={height}
                min={config.button._MIN_HEIGHT}
                max={config.button._MAX_HEIGHT}
                bsSize="sm"
              />
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <Label for="iframe-constructor-button-border-radius" className="no-margin">
            <FormattedMessage
              id="iframe_constructor.сontrols.button.border_radius.text"
              defaultMessage="Button round corners (px)"
            />
          </Label>
          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.button.borderRadius}
                max={config.button._MAX_BORDER_RADIUS}
                min={config.button._MIN_BORDER_RADIUS}
                onChange={handleButtonChange}
                name="borderRadius"
                step={1}
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-button-border-radius"
                name="borderRadius"
                onChange={this.handleChange}
                onBlur={handleButtonChange}
                value={borderRadius}
                min={config.button._MIN_BORDER_RADIUS}
                max={config.button._MAX_BORDER_RADIUS}
                bsSize="sm"
              />
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <CustomControl
            id="ic__button-max-width-status"
            name="enabledMaxWidth"
            type="checkbox"
            className="custom-control-xs"
            value={'enabledMaxWidth'}
            onChange={handleButtonChange}
            checked={settings.button.enabledMaxWidth}
          >
            <FormattedMessage
              id="iframe_constructor.сontrols.button.max_width.text"
              defaultMessage="Maximum width of the button (px)"
            />
          </CustomControl>

          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.button.maxWidth}
                max={config.button._MAX_WIDTH}
                min={config.button._MIN_WIDTH}
                onChange={handleButtonChange}
                name="maxWidth"
                disabled={!settings.button.enabledMaxWidth}
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-button-max-width"
                name="maxWidth"
                onChange={this.handleChange}
                onBlur={handleButtonChange}
                value={maxWidth}
                min={config.button._MIN_WIDTH}
                max={config.button._MAX_WIDTH}
                bsSize="sm"
                disabled={!settings.button.enabledMaxWidth}
              />
            </Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}

export default IframeConstructorButtonControls;
